import { useQuery, QueryFunction } from 'react-query';
import {
    getAllRentals,
    GetRentalsQueries,
    Rental,
    GetMonthlyRentalParams,
    getMonthlyRentals,
    MonthlyRental,
} from '../../services/apiSLTP/materials/rentals';

type UseRentalsQueryOptions = {
    queries?: GetRentalsQueries;
};

const getRentals: QueryFunction<Rental[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseRentalsQueryOptions];
    const { queries } = options;

    const response = await getAllRentals(queries);
    return response.data;
};

export const useRentalsQuery = (options: UseRentalsQueryOptions) => {
    return useQuery(['rentals', options], getRentals);
};

type UseMonthlyRentalsQueryOptions = {
    params: GetMonthlyRentalParams;
};

const getMonthlyRentalsQuery: QueryFunction<MonthlyRental[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseMonthlyRentalsQueryOptions];
    const { params } = options;

    const response = await getMonthlyRentals(params);
    return response.data;
};

export const useMonthlyRentalsQuery = (options: UseMonthlyRentalsQueryOptions) => {
    return useQuery(['monthly rentaltype', options], getMonthlyRentalsQuery);
};
